import type { Strings } from '../index.ts';

/**
 * Die Wörter auf einer Zeile in einem Grid.
 *
 * `badge.live` bleibt `LIVE`: das Wort ist im Deutschen dasselbe und steht in der Ecke eines
 * Vorschaubilds, wo nur zwei Zeichen Platz haben.
 */
export const listing: Strings['listing'] = {
  verified: 'Verifiziert',
  autoGeneratedTitle:
    'YouTube hat diesen Kanal aus dem Katalog eines Künstlers erzeugt. Niemand lädt dort etwas hoch.',
  autoGenerated: 'Automatisch erstellt',

  badge: {
    live: 'LIVE',
    upcoming: 'Geplant',
  },

  meta: {
    views: (count) => `${count} Aufrufe`,
    subscribers: (count) => `${count} Abonnenten`,
    videos: (count) => `${count} Videos`,
  },

  playlistTag: 'Playlist',
  playlistTagWithCount: (count) => `Playlist · ${count} Videos`,

  search: {
    label: 'Diese Liste durchsuchen',
    activeTitle: (q) => `Es werden nur Einträge gezeigt, die zu „${q}“ passen`,
    placeholder: 'Nach Titel suchen',
    clear: 'Suche löschen',
    submit: 'Suche beenden',
    noMatches: (q) => `Hier passt nichts zu „${q}“.`,
  },

  preview: {
    loading: 'Vorschau…',
    failed: 'Keine Vorschau',
  },

  progress: {
    watched: 'Gesehen',
    resume: 'Fortsetzen',
    complete: 'Du hast das bis zum Ende gesehen.',
    inHistory: 'Dieses Video ist in deinem Wiedergabeverlauf.',
    stoppedAt: (position) => `Du hast bei ${position} aufgehört. Beim Öffnen geht es dort weiter.`,
    stoppedAtOf: (position, duration) =>
      `Du hast bei ${position} von ${duration} aufgehört. Beim Öffnen geht es dort weiter.`,
  },
};
